import { defineMessages } from 'react-intl'

export interface Message {
  id: string
  defaultMessage: string
}

export const messages = defineMessages({
  LABEL_CONTACT_LAB_WATER_SPECIALIST: {
    id: 'LABEL_CONTACT_LAB_WATER_SPECIALIST',
    defaultMessage: 'Contact Lab Water Specialist',
  },
  LABEL_LAB_WATER_CONTACT_SPECIALIST: {
    id: 'LABEL_LAB_WATER_CONTACT_SPECIALIST',
    defaultMessage: 'Contact Specialist',
  },
  LABEL_SHOPPING_HELP: {
    id: 'LABEL_SHOPPING_HELP',
    defaultMessage: 'Need shopping help?',
  },
  LABEL_LAB_WATER_SPECIALIST_PHONE: {
    id: 'LABEL_LAB_WATER_SPECIALIST_PHONE',
    defaultMessage: '1 800-900-2222',
  },
  LABEL_MILLIQSQ_SPECIALIST_PHONE: {
    id: 'LABEL_MILLIQSQ_SPECIALIST_PHONE',
    defaultMessage: 'Call 1 800-900-2222',
  },
  LABEL_ADDITIONAL_SHOPPING_HELP_CALL: {
    id: 'LABEL_ADDITIONAL_SHOPPING_HELP_CALL',
    defaultMessage: 'Call',
  },
})

export default messages
